export default __webpack_public_path__ + "static/media/016-gate of all nations.0d5644ec.svg";